import React,{useEffect} from 'react';
import { useHistory } from 'react-router-dom';

import Header from '../Includes/Header';
import Footer from '../Includes/Footer';
import TituloPagina from '../Includes/Titulos';
import api from '../../services/api';
import { useTranslation } from 'react-i18next';

export default function Obrigado(){
    const history = useHistory();
    const BASE_URL = 'https://agrobrazilapp.com/';
    const USER_EMAIL = sessionStorage.getItem('email');
    const USER_TOKEN = sessionStorage.getItem('token');
    const selectedPlan = JSON.parse(sessionStorage.getItem('selectedPlan'));
    const { t } = useTranslation();
    var axios = require('axios');
var FormData = require('form-data');
var data = new FormData();


    useEffect(() => {
   
     //puxa historico dos dados pra autenticar os dados da pagina 
         api.get(`${BASE_URL}`, {
             headers: {
                 'USER_EMAIL': USER_EMAIL,
                 'USER_TOKEN': USER_TOKEN,
             }
         }).then(response => {
 
         }).catch(err => {
             if (err.status === 401) {
                 history.push('/');
             }
         });
       
 
     }, [USER_EMAIL, USER_TOKEN, history]);
    return(
        <div >
            <div class="address-container">
            <Header />

           <TituloPagina titulo={ t('pages.thanks.title') } />
            <div class="body-address">
                <h2> { t('pages.thanks.info') } </h2>
            <h3 class="text-config">{selectedPlan.name} - {selectedPlan.price}</h3>
            <link rel="stylesheet" href="https://cdnjs.cloudflare.com/ajax/libs/toastr.js/latest/toastr.min.css" />
                <div class="all-inputs-center">
                
                </div>
            </div>
            
            <Footer />
            </div>
        </div>
    );
}
